import { render, staticRenderFns } from "./AdvancedFixing.vue?vue&type=template&id=2bda7789&"
import script from "./AdvancedFixing.vue?vue&type=script&lang=js&"
export * from "./AdvancedFixing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports